export const customComponentRef = 'custom-component';
